import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IframePanelComponent } from 'components/core/workspace/iframe-panel.component';
import { QuestionTagConstants } from 'constants/QuestionTagConstants';
import { environment } from 'environments/environment';
import 'extensions/conversion';
import { SiteModel } from 'models/generated/Distribution.Api.Models.Site';
import { OrderLineModel } from 'models/generated/Entities.GormCrm.OrderLine';
import { CompanyDataProvider } from 'services/company-data-provider';
import { NavigationService } from 'services/navigation.service';
import { QuestionnaireService } from 'services/questionnaire.service';

@Injectable()
export class AiBuilderService {

	private useIFrame = false;
	private websiteNotesQuestion = 'd6113ad4-59fa-4878-af58-86403a4ffe12'; // TODO #22012 Use tags to indicate questionnaire questions used for special purposes
	private aiBuilderInputs: Record<string, string> = {
		gormSiteId: 'GORM_siteId',
		gormEnv: 'GORM_environment',
		companyName: 'Firmanavn',
		domain: 'Slut domæne',
		vat: 'CVR',
		business: 'Branche',
		phone: 'Telefon',
		email: 'Email',
		address: 'Adresse',
		notes: 'Noter fra tidligere samtaler'
	};

	constructor(
		private readonly questionnaireService: QuestionnaireService,
		private readonly navigation: NavigationService) {
	}

	async launchAiBuilder(site: SiteModel, dataProvider: CompanyDataProvider): Promise<void> {
		const companyInfo = await dataProvider.getCompany();
		const productPlan = (await dataProvider.getAllProductPlansAndAccountingPlans()).find(pp => pp.id == site.productPlanId);

		const formData = {
			gormSiteId: site.id!,
			gormEnv: environment.environment,
			companyName: companyInfo.name,
			domain: site.pointers[0]?.name ?? '',
			vat: companyInfo.vatNumber,
			business: companyInfo.businessName,
			phone: companyInfo.primaryContact?.contactPhones[0].number ?? '',
			email: companyInfo.primaryContact?.emailAddress ?? '',
			address: `${companyInfo.address}, ${companyInfo.zipcode} ${companyInfo.city}`,
			notes: await this.getNotesFromOrder(companyInfo.id!, productPlan?.orderLines)
		};

		const url = `${environment.aiBuilderUrl}?${this.getQueryString(formData)}`;
		if (this.useIFrame) this.navigation.openPopup(IframePanelComponent, 'site.ai-builder.popup-header').then(view => view.url = url);
		else window.open(url, '_blank')?.focus();
	}

	private async getNotesFromOrder(companyId: string, orderLines?: OrderLineModel[]) {
		if (!orderLines || orderLines.length == 0) return '';

		const newestOrderLine = [...orderLines].sort((a, b) => a.order?.created! > b.order?.created! ? 1 : 0)[0];
		const replies = await this.questionnaireService.getQuestionRepliesByTag(QuestionTagConstants.websiteDesign, companyId, newestOrderLine.orderId, undefined);

		return replies
			.flatMap<string>(reply => reply.replyData ? JSON.parse(reply.replyData) : [])
			.map(reply => reply.getStringFromHtml())
			.join('\n');
	}

	private getQueryString(object: Record<string, string>) {
		let params = new HttpParams();
		for (const key in object) params = params.set(this.aiBuilderInputs[key], object[key]);
		return params.toString();
	}
}
